const constants = {
    mydashboard: {
        dashboardOverview: "Widgets that provides “Average” snapshots and visualizations of core data. It helps to quickly view and compare figures over different date range.",
        dailyTrend: "Gives a combined idea over Productive,  Non-Core activity and Ideal time log captured for set of user over different date range.",
        inOutTrend: "Time stamping of Individual / Group user activities.",
        dailyTimeLog: "Record of 24 hours around the clock time stamping of Individual / Group  user activities.",
        categories: "Enterprise grouping of applications and websites based on its core characteristics and Nature, related to hourly usage and its percentage of utilizations.",
        applications: "Listing of applications basis of its hourly usage and percentage of utilizations.",
        websites: "Listing of websites basis of its hourly usage and percentage of utilizations.",
        productiveApps: "Potential application indicating high yield values.",
        nonCoreApps: "User level Consideration of peripheral or incidental activities outside business applications."
    },
    myCalender: {
        calender: "A calendar widgets for displaying monthly incidental activities related to self and subordinate users.",
        date: "Click here to analyze data in Dashboard"
    },
    teams: {
        myteamTab: "Quick Journey over team members related activities.",
        dashboardOverview: "widgets that provides “Average” snapshots and visualizations of  core data related to team members. It helps to quickly view and compare figures over different date range.",
        daywiseTimelog: "Combined idea over Productive,  Non-Core activity and Ideal time log captured for associated team  over different date range.",
        loggedInProdHrs: "Combined indicator of Average, Active & Productive hrs. Giving a   snapshots and visualizations of captured core data of associated teams  over different date range.",
        compareGroup: "Group level combined indicator of Productive,  Non-Core activity and Ideal time log captured for associated team members  over different date range.",
        AppVsWeb: "Segregated analytical view of time spent over software applications and websites by associated team members.",
        AbsenceReport: "Detail view of team members whose system was not Active in selected date range. Holidays and off working hours are not considered in this report"
    },
    userManagement: {
        managemntTab: "Control for administrator to mobilize and enhance the ability to manage system users and their activities."
        , pendingRequest: "List of User with verification of email is pending , to join TrakZo"
        , addRequest: "Requested User will receive invite over Email, to join TrakZo",
        Authorize: "Authorize"
    },
    report: {
        reportOverview: "Organised view to review summary of user activities and its related ecosystem."
    },
    screenShot: {
        screenshotConfiguration: "Interface control to engineer the expected performance of capturing user screen image in timely manner and store it digitally."
        , screenshotList: "Digital storage of user screen image, captured on timely manner for later references."
    },
    RestrictedAppUsage: {
        header: "Restricted App Usage"
    },
    worktime: {
        header: "Work Time configuration"
    },
    trakzoLite: {
        header: "User with TrakZo Lite"
    },
    userWiseReport: {
        // header:"User Wise Details Report",
        // summaryHeader: "User Wise Details Report Summary",
    },

    userReports:{
        header:"User Wise Details Report"
    },
}

export default constants